<template>
  <div id="vue-touch">
    <v-touch  class="vue-touch"
              @tap="test"
              @swipeleft="onSwipeLeft"
              @swiperight="onSwipeRight"  >
      {{text}}
      <div v-show="page == 1">Page 1</div>
      <div v-show="page == 2">Page 2</div>
      <div v-show="page == 3">Page 3</div>
      <div v-show="page == 4">Page 4</div>
    </v-touch>
  </div>
</template>

<script>
export default {
  name: 'vue-touch',
  data () {
    return {
      text: '',
      page: 1
    }
  },
  methods: {
    test (e) {
      this.text = e.type
    },
    onSwipeRight (e) {
      this.text = e.type
      this.page--
      if (this.page <= 0) {
        this.page = 4
      }
    },
    onSwipeLeft (e) {
      this.text = e.type
      this.page++
      if (this.page > 4) {
        this.page = 1
      }
    }
  }
}
</script>

<style>
.vue-touch {
  width: 100px;
  height: 100px;
  background-color: red;
}
</style>


// WEBPACK FOOTER //
// component.vue?62e64f62